<template>
  <div class="col-12">
    <div class=" row text-center ml-5">
      <h3 class="ui inverted purple text"><strong>Select Account Type</strong>
      </h3>
      <p class="text-muted fw-light mt-4">Please note every account creation request made on this platform requires a
        deposit through EcoCash.</p>
    </div>

    <div class="row d-flex justify-content-center align-items-center mt-5">
      <div class="col-11 col-lg-9">

        <div class="row mb-5">
          <div class="col-sm-6 mb-3">
            <div class="card card-shadow">
              <div class="card-body">
                <h4 class="card-title"><strong>iSave Account</strong></h4>
                <p class="card-text text-muted fw-light">Account opening fee: ZiG100 Montlhy service fee: ZiG500 Monthly
                  transaction limit:ZiG 400,000</p>
                <br>
                <br>
                <button class="ui purple right floated  button" @click="isave()">
                  Next
                </button>
              </div>
            </div>
          </div>
          <div class="col-sm-6 mb-3">
            <div class="card card-shadow">
              <div class="card-body">
                <h4 class="card-title"><strong>Current Account</strong></h4>
                <p class="card-text text-muted fw-light">Supporting documents required: Valid National ID or Passport,
                  Proof of income, Proof of residence e.g utility bill Monthly service fee: ZWL1,000 or USD 5 Monthly
                  transaction limit: Nil</p>
                <button class="ui purple right floated button" @click="t24()">
                  Next
                </button>
              </div>
            </div>
          </div>
          <!-- <div class="col-sm-6 mb-3">
            <div class="card card-shadow">
              <div class="card-body">
                <h4 class="card-title"><strong>Remit Account</strong></h4>
                <p class="card-text text-muted fw-light">A wallet that allows you to do local remittance as well as other transactions</p>
                <button class="ui purple right floated button" @click="remit()">
                  Next
                </button>
              </div>
            </div>
          </div> -->
          </div>
          <div class="col-sm-6 mb-3">
            <div class="card card-shadow">
              <div class="card-body">
                <h4 class="card-title"><strong>Diaspora Account</strong></h4>
                <p class="card-text text-muted fw-light">A wallet that allows you to do local remittance as well as other
                  transactions</p>
                <button class="ui purple right floated button" @click="diaspora()">
                  Next
                </button>
              </div>
            </div>
          </div>
        </div>

        <div class="mt-5">
          <button @click="back()" class="ui grey button fluid">Back</button>
        </div>
      </div>
    </div>
</template>
<script>
import baseMethods from "@/utils/baseMethods";
import { URLS } from "@/utils/constants";
import { useAccountOpeningStore } from '@/stores/accountOpening';

export default {
  name: "AccountType",
  setup() {
    const accountOpeningStore = useAccountOpeningStore();
    return { accountOpeningStore };
  },
  data() {
    return { count: 0, account: [] };
  },
  computed: {
    activeAccountTypes() { return this.accountOpeningStore.activeAccountTypes; },
  },
  mounted() {
 //   this.getAccountsApplications();
  },
  methods: {
    getAccountsApplications() {
      this.get(URLS.accounts + '/active-accounts', false)
        .then(res => {
          this.accounts = res.body;
          console.log(this.accounts);
          if (!res) return;
          if (res.errors) return this.errors = res.errors;

        })
    },
    back() {
      this.$router.push("/account-opening/terms-and-conditions");
    },
    isave() {
      // Retrieve data from Vuex store
      const accountTypesWithCurrency = this.activeAccountTypes || [];

      // Filter by account type 'ZSS'
      const filteredData = accountTypesWithCurrency.filter(account => {
        return account.accountType === 'ZSS';
      });

      // Count occurrences
      const count = filteredData.length;

      if (count > 0) {
        this.$router.push("/account-opening/iSave-account-already-exist");
      }
      else {
        this.setAccountType("ISAVE");
        this.$router.push("/account-opening/customer-details");
      }

    },
    t24() {
      this.setAccountType("T24");
      this.$router.push("/account-opening/currency-type");
    },
    remit() {
      this.selectAccountAndCurrency({
        accountType: "REMIT",
        currencyType: "USD",
      });
      this.$router.push("/account-opening/remit-customer-details");
    },
    diaspora() {
      this.setAccountType("DIASPORA");
      this.$router.push("/account-opening/diaspora-currency-type");
    },
    submitForm() { },
    setAccountType(type) { this.accountOpeningStore.setAccountType(type); },
    selectAccountAndCurrency(data) { this.accountOpeningStore.selectAccountAndCurrency(data); },
    ...baseMethods,
  }
};
</script>